import { useState } from 'react';
import Web3 from "web3"
import web3Config, { INFI_CONTRACT, USDT_CONTRACT } from "./web3Config";
import Erc20Abi from "./Erc20Abi.json"
import InfiABI from './InfiAbi.json'
import InfiUsdtLiquidityAbi from "./InfiUsdtLiquidityAbi.json";
import { erc20ABI } from 'wagmi';

////New Runing Code
// const validateProvider = async (walletProvider) => {

//   walletProvider = await walletProvider;
//   if (!walletProvider) {
//     return {
//       status: false,
//       message: `Please connect your web3 wallet`,
//     }
//   }
//   // console.log({ walletProvider })
//   const web3 = new Web3(walletProvider)
//   let accounts = await walletProvider.request({   /* New */
//     method: "eth_requestAccounts",                 /* New */
//   })

//   // const accounts = await web3.eth.getAccounts()
//   const currentProvider = await web3.currentProvider;
//   const chainId = await web3.currentProvider.chainId;
//   // let ccc = await currentProvider.getChainId()
//   // console.log({ currentProvider, chainId })

//   if (web3.utils.toHex(parseInt(chainId)) != parseInt(web3Config.CHAIN) && parseInt(web3Config.CHAIN) != parseInt(chainId)) {
//     return {
//       status: false,
//       message: `Please select ${web3Config.NETWORK} network`,
//     }
//   }
//   return {
//     status: true,
//     web3
//   }
// }

const validateProvider = async (walletProvider) => {
  walletProvider = await walletProvider;
  if (!walletProvider) {
    return {
      status: false,
      message: `Please connect your web3 wallet`,
    }
  }
  const web3 = new Web3(walletProvider)
  // let accounts = await walletProvider.request({   /* New */
  //   method: "eth_requestAccounts",                 /* New */
  // })
  // const currentProvider = await web3.currentProvider;

  const maticNetwork = {
    chainId: web3Config.CHAIN,
    chainName: web3Config.NETWORK,
    nativeCurrency: {
      name: web3Config.NETWORK,
      symbol: web3Config.SYMBOL,
      decimals: 18,
    },
    rpcUrls: web3Config.POLYGON_RPC,
    blockExplorerUrls: web3Config.Explore
  }

  const chainId = await walletProvider.request({method: 'eth_chainId'})
  const decimalChainId = parseInt(chainId,16)
  if (decimalChainId !== web3Config.CHAIN) {
    try{    
      await walletProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: web3.utils.toHex(web3Config.CHAIN) }],
    });
   } catch(switchError) {
    if (switchError.code === 4902 || switchError.code === 32603) {
      try {
        await walletProvider.request({
          method: "wallet_addEthereumChain",
          params: [maticNetwork],
        });
      } catch (addError) {
        console.error(`Failed to add network:`, addError);
        return {
          status: false,
          message: `Failed to add the network. Please try again.`,
        };
   }
  } else {
    console.error(`Failed to switch network:`, switchError);
        return {
          status: false,
          message: `Failed to switch to the required network. Please try again.`,
        };
  }
}
  } 
  return {
    status: true,
    web3
  }
}
  

export const BloackchainGetTokenBalance = async (walletAddress, tokenAddress, walletProvider) => {
  try {
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;
    //console.log({chainId});


    let contractErc20 = new web3.eth.Contract(Erc20Abi, tokenAddress);

    let balance = await contractErc20.methods.balanceOf(walletAddress).call();

    let decimals = await contractErc20.methods.decimals().call();

    return {
      status: true,
      balance: parseInt(balance) / 10 ** parseInt(decimals)
    }
  } catch (error) {
    console.error(error);
  }
};

export const BloackchainGetTokenPrice = async (request) => {
  try {
    const { tokenName, liquidityContract, walletProvider, infiDecimal, usdtDecimal } = request;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let contractLiquidity = new web3.eth.Contract(InfiUsdtLiquidityAbi, liquidityContract);
    if (tokenName == "INFI") {
      let result = await contractLiquidity.methods.getInfiPrice().call();
      let price = parseInt(result) / 10 ** parseInt(usdtDecimal);
      return {
        status: true,
        price: price.toFixed(6)
      }
    }
    else {
      let result = await contractLiquidity.methods.getUsdtPrice().call();
      let price = parseInt(result) / 10 ** parseInt(infiDecimal);
      return {
        status: true,
        price: price.toFixed(6)
      }
    }
  }
  catch (error) {
    console.error(error);
  }
};

export const BloackchainExpectedReceivableAmount = async (request) => {
  try {
    let { symbol, liquidityContract, infiContract, usdtContract, amount, isBurn, walletProvider, infiDecimal, usdtDecimal } = request;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;

    let contractLiquidity = new web3.eth.Contract(InfiUsdtLiquidityAbi, liquidityContract);
    let response = {};
    let receiveTokenAddress = infiContract;
    let receiveTokenDecimal = infiDecimal;

    if (symbol == "USDT") {
      let amoutToSwap = amount * 10 ** parseInt(usdtDecimal);
      amoutToSwap = amoutToSwap.toLocaleString('fullwide', { useGrouping: false });
      let result = await contractLiquidity.methods.expectedInfiToReceive(amoutToSwap.toString()).call();
      let infiPrice = await contractLiquidity.methods.getInfiPrice().call();
      let amountToReceive = parseInt(result.actualInfiToReceive) / 10 ** parseInt(infiDecimal);
      let totalFees = parseInt(result.feeAmountToSbse) / parseInt(infiPrice);
      // totalFees = totalFees / 10 ** parseInt(usdtDecimal);
      console.log({result})
      response = {
        status: true,
        expectedResult: result,
        amountToReceive: amountToReceive.toFixed(6),
        totalFees: totalFees.toFixed(6),
      }
    }
    else {
      receiveTokenAddress = usdtContract;
      receiveTokenDecimal = usdtDecimal;
      let amoutToSwap = amount * 10 ** parseInt(infiDecimal);
      amoutToSwap = amoutToSwap.toLocaleString('fullwide', { useGrouping: false });
      let result = await contractLiquidity.methods.expectedUsdtToReceive(amoutToSwap.toString(), isBurn).call();
      let amountToReceive = parseInt(result.actualUsdtToReceive) / 10 ** parseInt(usdtDecimal);
      let totalFees = parseInt(result.finalFee) / 10 ** parseInt(usdtDecimal);

      
      response = {
        status: true,
        expectedResult: result,
        amountToReceive: amountToReceive.toFixed(6),
        totalFees: totalFees.toLocaleString('fullwide', { useGrouping: false })
      }
    }
    // Price impact
    let contractErc20 = new web3.eth.Contract(Erc20Abi, receiveTokenAddress);
    let receiveTokenCurrentBalanceOfPool = await contractErc20.methods.balanceOf(liquidityContract).call();
    receiveTokenCurrentBalanceOfPool = parseInt(receiveTokenCurrentBalanceOfPool) / 10 ** parseInt(receiveTokenDecimal);
    receiveTokenCurrentBalanceOfPool = receiveTokenCurrentBalanceOfPool.toLocaleString('fullwide', { useGrouping: false });
    let currentPriceImpact = parseFloat(response.amountToReceive) / parseFloat(receiveTokenCurrentBalanceOfPool) * 100;

    response.currentPriceImpact = currentPriceImpact.toFixed(2);
    return response;

  } catch (error) {
    console.error('error', error);
  }
}

export const BloackchainCheckAllowanceAndApprove = async (req) => {
  try {
    const { walletProvider, walletAddress, contractAddress, amount, liquidityContract } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let erc20Contract = new web3.eth.Contract(Erc20Abi, contractAddress);

    let decimals = await erc20Contract.methods.decimals().call();
    let tokenAmount = parseFloat(amount).toFixed(6);
    tokenAmount = (tokenAmount * 10 ** parseInt(decimals)).toLocaleString('fullwide', { useGrouping: false })

    let checkAllowance = await erc20Contract.methods.allowance(walletAddress, liquidityContract).call();
    let allowanceAmount = parseFloat((parseInt(checkAllowance) / 10 ** parseInt(decimals)).toFixed(6));
    console.log({ allowanceAmount, tokenAmount });
    // if (parseFloat(allowanceAmount) < parseFloat(tokenAmount)) {

    //   tokenAmount = tokenAmount * 10 ** parseInt(decimals);
    //   tokenAmount = tokenAmount.toLocaleString('fullwide', { useGrouping: false })
      
      let trx = await erc20Contract.methods.approve(liquidityContract.toString(), tokenAmount);
      let encodeData = trx.encodeABI();
      let gasPrice = await web3.eth.getGasPrice();

      
      let gasLimit = await web3.eth.estimateGas({
        gasPrice: web3.utils.toHex(gasPrice),
        to: contractAddress,
        from: walletAddress,
        data: encodeData,
        chainId: chainId,
      });
      

      const txData = await web3.eth.sendTransaction({
        gasPrice: web3.utils.toHex(gasPrice),
        gas: web3.utils.toHex(gasLimit),
        to: contractAddress,
        from: walletAddress,
        data: encodeData,
        chainId: chainId,
      });
      return {
        status: true,
        hash: txData.transactionHash
      }
  } catch (error) {
    return {
      status: false,
      message: error?.data?.message || "Something went wrong. Please try agian." // error.toString()
    }
  }
};


export const getLiquidityPoolDetial = async (request) => {
  try {

    let { walletProvider, walletAddress, liquidityContract } = request;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;

    let contractLiquidity = new web3.eth.Contract(InfiUsdtLiquidityAbi, liquidityContract);
    console.log({ liquidityContract })
    let totalLp = await contractLiquidity.methods.totalSupply().call();
    let userLpToken = await contractLiquidity.methods.balanceOf(walletAddress).call();
    let isPairCreated = true;

    totalLp = (parseInt(totalLp) / 10 ** 18).toFixed(6);
    if (parseFloat(totalLp) == 0) {
      isPairCreated = false;
    }
    let UsdtPriceInInfi = await contractLiquidity.methods.getUsdtPrice().call();
    let InfiPriceInUsdt = await contractLiquidity.methods.getInfiPrice().call();

    return {
      status: true,
      UsdtPriceInInfi: parseFloat((parseInt(UsdtPriceInInfi) / 10 ** 18).toFixed(6)),
      InfiPriceInUsdt: parseFloat((parseInt(InfiPriceInUsdt) / 10 ** 6).toFixed(6)),
      totalLpToken: parseFloat(totalLp),
      userLpToken: parseFloat((parseInt(userLpToken) / 10 ** 18).toFixed(6)),
      isPairCreated
    }

  } catch (error) {
    console.error('error', error);
  }
}

export const BloackchainSwapToken = async (req) => {
  try {
    const { walletProvider, walletAddress, contractAddress, amount, fromToken, toToken, liquidityContract, isBurn } = req;
    const validate = await validateProvider(walletProvider);
    console.log({ req })
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let erc20Contract = new web3.eth.Contract(Erc20Abi, contractAddress);
    let infiUsdtliquidityContract = new web3.eth.Contract(InfiUsdtLiquidityAbi, liquidityContract);
    let decimals = await erc20Contract.methods.decimals().call();
    // let actualAmount = parseFloat(amount).toFixed(6);

    let tokenAmount = amount * 10 ** parseInt(decimals);
    tokenAmount = tokenAmount.toLocaleString('fullwide', { useGrouping: false });

    // let checkAllowance = await erc20Contract.methods.allowance(walletAddress.toString(), liquidityContract.toString()).call();
    // let allowanceAmount = parseFloat((parseInt(checkAllowance) / 10 ** parseInt(decimals)).toFixed(6));
    // console.log(parseFloat(allowanceAmount), parseFloat(actualAmount));

    // if (parseFloat(allowanceAmount) < parseFloat(actualAmount)) {
    //   console.log('Approval in progress...')
    //   let trx = await erc20Contract.methods.approve(liquidityContract, tokenAmount.toString());
    //   let encodeData = trx.encodeABI();
    //   let gasPrice = await web3.eth.getGasPrice();

    //   let gasLimit = await web3.eth.estimateGas({
    //     gasPrice: web3.utils.toHex(gasPrice),
    //     to: contractAddress,
    //     from: walletAddress,
    //     data: encodeData,
    //     chainId: chainId,
    //   });

    //   await web3.eth.sendTransaction({
    //     gasPrice: web3.utils.toHex(gasPrice),
    //     gas: web3.utils.toHex(gasLimit),
    //     to: contractAddress,
    //     from: walletAddress,
    //     data: encodeData,
    //     chainId: chainId,
    //   });
    // }

    console.log({
      swap: tokenAmount,
      isburn: isBurn,
      liquidityContract,
      tokenAmount,
      walletAddress,
      contractAddress,
      fromToken
    })
    let trx = ``;
    if (fromToken == "INFI") {
      console.log('swapInfiToUsdt')
      console.log({tokenAmount : tokenAmount.toString(), isBurn})
      trx = await infiUsdtliquidityContract.methods.swapInfiToUsdt(tokenAmount.toString(), isBurn);
    }
    else {
      console.log('swapUsdtToInfi')
      trx = await infiUsdtliquidityContract.methods.swapUsdtToInfi(tokenAmount.toString());
    }

    let encodeData = trx.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: liquidityContract,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    console.log('hello');

    const txData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: liquidityContract,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    return {
      status: true,
      hash: txData.transactionHash
    }

  } catch (error) {
    console.log(error);
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
};


export const BlockchainRemoveLiquidity = async (req) => {
  try {
    const { walletProvider, walletAddress, LpToken, liquidityContract } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let infiUsdtliquidityContract = new web3.eth.Contract(InfiUsdtLiquidityAbi, liquidityContract);

    let tokenAmount = LpToken * 10 ** parseInt(18);
    tokenAmount = tokenAmount.toLocaleString('fullwide', { useGrouping: false });

    let trx = await infiUsdtliquidityContract.methods.removeLiquidity(tokenAmount.toString());

    let encodeData = trx.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();

    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: liquidityContract,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });

    const txData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: liquidityContract,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    return {
      status: true,
      hash: txData.transactionHash
    }

  } catch (error) {
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
};




export const BlockchainAddLiquidity = async (req) => {
  try {
    const { walletProvider, walletAddress, infiAmount, usdtAmount, liquidityContract, isPairCreated } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let infiUsdtliquidityContract = new web3.eth.Contract(InfiUsdtLiquidityAbi, liquidityContract);

    let infiTokenAmount = infiAmount * 10 ** parseInt(18);
    infiTokenAmount = infiTokenAmount.toLocaleString('fullwide', { useGrouping: false });

    let usdtTokenAmount = usdtAmount * 10 ** parseInt(6);
    usdtTokenAmount = usdtTokenAmount.toLocaleString('fullwide', { useGrouping: false });


    let trx = "";
    if (isPairCreated) {
      trx = await infiUsdtliquidityContract.methods.addLiquidity(infiTokenAmount.toString());
    } else {
      trx = await infiUsdtliquidityContract.methods.createPair(infiTokenAmount.toString(), usdtTokenAmount.toString());
    }

    let encodeData = trx.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();

    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: liquidityContract,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });

    const txData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: liquidityContract,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    return {
      status: true,
      hash: txData.transactionHash
    }

  } catch (error) {
    console.log({ error })
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
};




export const getCalculateAmountForLiquidity = async (request) => {
  try {

    let { walletProvider, amount, coin, liquidityContract } = request;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;

    let contractLiquidity = new web3.eth.Contract(InfiUsdtLiquidityAbi, liquidityContract);

    let returnAmount = 0;
    let usdtForLp = 0;
    let infiForLp = 0;

    if (coin == 'INFI') {
      let getInfiPrice = await contractLiquidity.methods.getInfiPrice().call();
      returnAmount = parseFloat(((parseInt(getInfiPrice) / 10 ** 6) * amount).toFixed(6))

      infiForLp = amount * 10 ** 18;
      usdtForLp = returnAmount * 10 ** 6;

    } else {
      let getUsdtPrice = await contractLiquidity.methods.getUsdtPrice().call();
      returnAmount = parseFloat(((parseInt(getUsdtPrice) / 10 ** 18) * amount).toFixed(6))

      usdtForLp = amount * 10 ** 6;
      infiForLp = returnAmount * 10 ** 18;
    }


    usdtForLp = usdtForLp.toLocaleString('fullwide', { useGrouping: false });
    infiForLp = infiForLp.toLocaleString('fullwide', { useGrouping: false });

    let getLp = await contractLiquidity.methods.calculateLiquidityToMint(infiForLp.toString(), usdtForLp.toString()).call();
    getLp = parseFloat((parseFloat(getLp) / 10 ** 18).toFixed(4))

    return {
      status: true,
      returnAmount: returnAmount,
      getLpToken: getLp
    }

  } catch (error) {
    return {
      status: false,
      returnAmount: 0,
      getLpToken: 0
    }
  }
}

export const TokenBalanceData = async () => {
  try {
    const chains = [
      {
        name:"POLYGON",
        RPC: web3Config.POLYGON_RPC,
        USDT: web3Config.USDT_CONTRACT
      },
      {
        name:"AVAX",
        RPC: web3Config.AVAX_RPC,
        USDT: web3Config.USDT_AVAX
      },
      {
        name:"ARB",
        RPC: web3Config.ARB_RPC,
        USDT: web3Config.USDT_ARB
      },
      {
        name:"ETH",
        RPC: web3Config.ETH_RPC,
        USDT: web3Config.USDT_ETH
      },
      {
        name:"BASE",
        RPC: web3Config.BASE_RPC,
        USDT: web3Config.USDT_BASE
      },
    ]

    const validateInfi = await validateProvider2(web3Config.POLYGON_RPC);
    if (!validateInfi.status) {
      return validateInfi;
    }
    let web3 = validateInfi.web3;


    let Inficontract = new web3.eth.Contract(InfiABI, web3Config.INFI_CONTRACT);
    let infiDecimals = await Inficontract.methods.decimals().call();


    let balanceInfiReserve = await Inficontract.methods.balanceOf(web3Config.RESERVE).call();
    let balanceInfiTreasury = await Inficontract.methods.balanceOf(web3Config.TREASURY).call();

    let totalUsdtReserve = 0;
    let totalUsdtTreasury = 0;

    for (const chain of chains) {
      const validate = await validateProvider2(chain.RPC)
      if(!validate.status) {
        return validate
      }
      const web3 = validate.web3
      let usdtContract = new web3.eth.Contract(Erc20Abi,chain.USDT);
      let balanceUsdtReserve = await usdtContract.methods.balanceOf(web3Config.RESERVE).call()
      let balanceUsdtTreasury = await usdtContract.methods.balanceOf(web3Config.TREASURY).call()
      //console.log(balanceUsdtReserve,balanceUsdtTreasury,"all usdt")
      totalUsdtReserve += Number(balanceUsdtReserve)/10**6;
      totalUsdtTreasury += Number(balanceUsdtTreasury)/10**6;
    }

    const validateBnb = await validateProvider2(web3Config.BNB_RPC);
    if (!validateBnb.status) {
      return validateBnb;
    }
    let web3Bnb = validateBnb.web3;


    let UsdtBnbcontract = new web3Bnb.eth.Contract(Erc20Abi, web3Config.USDT_BNB);

    let balanceUsdtBnbReserve = await UsdtBnbcontract.methods.balanceOf(web3Config.RESERVE).call();
    let balanceUsdtBnbTreasury = await UsdtBnbcontract.methods.balanceOf(web3Config.TREASURY).call();
    //console.log(balanceUsdtBnbReserve,balanceUsdtBnbTreasury,"all bnb usdt")
    let usdtBnbReserve = Number(balanceUsdtBnbReserve)/10**18;
    let usdtBnbTreasury = Number(balanceUsdtBnbTreasury)/10**18


    let finalUsdtReserve = totalUsdtReserve + usdtBnbReserve;
    let finalUsdtTreasury = totalUsdtTreasury + usdtBnbTreasury;
    //let finalUsdtSbse = totalUsdtSbse + usdtBnbSbse


    return {
      status: true,
      InfiBalanceReserve: (parseInt(balanceInfiReserve) / 10 ** parseInt(infiDecimals)).toFixed(4),
      InfiBalanceTreasury: (parseInt(balanceInfiTreasury) / 10 ** parseInt(infiDecimals)).toFixed(4),

      UsdtBalanceReserve: finalUsdtReserve.toFixed(2),
      UsdtBalanceTreasury: finalUsdtTreasury.toFixed(2),
      //UsdtBalanceSbse: finalUsdtSbse.toFixed(2)
    };

  } catch (error) {
    console.error(error);
    return {
      status: false,
      error: error.message
    };
  }
};


export const getSbseBalance = async () => {
  try {
    const validate = await validateProvider2(web3Config.POLYGON_RPC);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    const usdtContract = new web3.eth.Contract(erc20ABI,web3Config.USDT_CONTRACT)
    const usdcContract = new web3.eth.Contract(erc20ABI,web3Config.USDC_POL)
    const infiContract = new web3.eth.Contract(InfiABI,web3Config.INFI_CONTRACT)
    const wbtcContract = new web3.eth.Contract(erc20ABI,web3Config.WBTC_POL)

    const balanceUSDT = await usdtContract.methods.balanceOf(web3Config.SBSE_PFP).call();
    const balanceUSDC = await usdcContract.methods.balanceOf(web3Config.SBSE_PFP).call();
    const balanceINFI = await infiContract.methods.balanceOf(web3Config.SBSE_PFP).call();
    const balanceWBTC = await wbtcContract.methods.balanceOf(web3Config.SBSE_PFP).call();
    // console.log('infi', balanceINFI,'usdc',balanceUSDC,'usdt',balanceUSDT,'btc',balanceWBTC)

    return {
      status: true, 
      balance : {
        USDT_BAL:web3.utils.fromWei(balanceUSDT,'mwei') || '0',
        USDC_BAL:web3.utils.fromWei(balanceUSDC,'mwei') || '0',
        INFI_BAL:web3.utils.fromWei(balanceINFI,'ether') || '0',
        WBTC_BAL:web3.utils.fromWei(balanceWBTC,'gwei') || '0'
      }
    }
  } catch (error) {
    console.log('Error fetching wallet balance',error)    
  }
}

const validateProvider2 = async (walletProvider) => {
  console.log("validateProvider2");
  try {
    if (!walletProvider) {
      console.log("walletProvider");

      return {
        status: false,
        message: `Please connect your web3 wallet`,
      };
    }
    const web3 = new Web3(walletProvider);

    return {
      status: true,
      web3
    };
  } catch (error) {
    console.log("Error in validateProvider :", error);
    return {
      status: false,
      message: "Error in validating provider. Please try again.",
    };
  }
};